<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-One.html" xml:lang="en-US">
<div class="Basic-Text-Frame-2">
<p class="ch"><a id="Anchor-1">Chapter One</a></p><a id="Anchor-1">
<p class="sub">Saturday, September 9</p>
<p class="body-text-opening">Rachel Maxwell opened her eyes. The world remained black. She tried to lift her arms, but blistering pain attacked with the slightest movement. She was alive. That was all she was certain of. Death couldn’t hurt this bad.</p>
<p class="body-text">Her pupils slowly adjusted to the darkness, but the hammering inside her skull was so intense her brain couldn’t identify where she was or why. Random thoughts skirted her consciousness.</p>
<p class="body-text">A faint line of brightness on the other side of the room provided the only illumination. Most likely a space beneath a door, so there must be a light on somewhere. No windows to let in a scant glow of moonlight. No sounds except her own ragged breathing.</p>
<p class="body-text">She was on her back, stretched out, perhaps in a bed, perhaps not. Her fingers impulsively went to her face. Her cheeks felt swollen, but numb, the only part of her that didn’t ache. She struggled to focus.</p>
<p class="body-text">Fear swelled, crashing through her like ocean waves as scraps of nightmarish images crept through the shadows of her mind. The man dragging her into his truck. His creepy hands all over her.</p>
<p class="body-text">And then the punishing blows.</p>
<p class="body-text">Her stomach heaved as the memories grew more distinct. Not a nightmare, but horrifying reality.</p>
<p class="body-text">She forced her body to move, slid over until her hand touched what felt like rough, splintered wood. She rolled off what must be no more than a pallet of some kind and onto the hard floor. Every joint and muscle cried out for mercy as she forced herself to scoot up on her elbows and crawl toward the light.</p>
<p class="body-text">When she reached the door, she struggled to stand, her fingers clawing at the door frame until she could wrap them around the doorknob.</p>
<p class="body-text">She hesitated. If the door opened, it might only lead to more hell. But the faint hint of escape held sway. She turned the knob and shoved her body against it. The door didn’t budge.</p>
<p class="body-text">She beat on the door with her fists. Agony and hopelessness took hold as she slid back to the floor. Tears filled her eyes and sobs shook her pain-racked body. She’d been imprisoned by a monster. The worst was no doubt yet to come.</p>
<p class="pl-title">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_One.vue?eca8dbae